import { Text as RNText } from 'react-native'

import { styled, TextProps } from '../../styled'

export const Text = styled<TextProps>(RNText, { style: 'text' })
